<h4>Lista de Menu</h4>
<ul>
  <li>
    <a routerLink="/" routerLinkActive="active">Inicio</a>
  </li>
  <li>
    <a routerLink="/catalogo" routerLinkActive="active">Catalogo</a>
  </li>
</ul>
